// extracted by mini-css-extract-plugin
export default {"validation":"PasswordValidation_validation__TJq29","red":"PasswordValidation_red__s2nPg","green":"PasswordValidation_green__Cmkz6"};